import React, { SFC } from 'react';
import classNames from 'classnames';

export const ProgressSteps: SFC = ({ children }) => {
  return <ol className="mx-progress-steps">{children}</ol>;
};

interface StepProps {
  active?: boolean;
  complete?: boolean;
  hasChanges?: boolean;
  onClick?: () => void;
}

export const Step: SFC<StepProps> = ({ active, complete, hasChanges, onClick, children }) => {
  const onClickHandler = () => {
    if (typeof onClick === 'function') {
      onClick();
    }
  };

  return (
    <li
      className={classNames({
        'is-active': active,
        'is-complete': complete,
      })}
      onClick={onClickHandler}
    >
      <span>{children}</span>
      {hasChanges && <span className="has-changes" />}
    </li>
  );
};
